module.exports = __webpack_public_path__ + "img/aws.2c2d4eef.png";